var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.675,4.217c0.016-0.097,0.014-0.198-0.011-0.3c-0.097-0.402-0.495-0.651-0.905-0.552 c-0.029,0.006-2.905,0.67-6.513-0.795C7.98,0.838,4.729,3.4,4.593,3.51c-0.01,0.008-0.015,0.021-0.025,0.03 c-0.04,0.036-0.069,0.078-0.101,0.121C4.44,3.698,4.411,3.732,4.392,3.773c-0.02,0.041-0.028,0.085-0.04,0.13 c-0.014,0.051-0.028,0.1-0.031,0.153C4.321,4.069,4.313,4.08,4.313,4.094v17.182c0,0.414,0.336,0.75,0.75,0.75s0.75-0.336,0.75-0.75 v-8.603c0.768-0.496,3.036-1.672,5.868-0.523c2.104,0.854,3.977,1.065,5.318,1.065c1.262,0,2.052-0.188,2.117-0.203 c0.335-0.083,0.57-0.384,0.57-0.729V4.274C19.687,4.254,19.677,4.237,19.675,4.217z M12.246,10.76 c-2.761-1.122-5.091-0.444-6.432,0.204V4.484c0.77-0.49,3.056-1.666,5.868-0.524C13.786,4.814,15.659,5.025,17,5.025 c0.464,0,0.863-0.026,1.187-0.058v6.681C17.176,11.768,14.927,11.848,12.246,10.76z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.6afc2f29ea6528693759d410bd7c522f.svg";
export { ForwardRef as ReactComponent };